import { KeyArgsFunction } from '@apollo/client/cache/inmemory/policies';
import { BillFilters, DateFromTo, OrderFilters } from '../generated/graphql';

type Filters = OrderFilters | BillFilters;
export const buildCacheKeys: KeyArgsFunction = (_args, context) => {
    const queryVariables = context.variables;
    if (!queryVariables) {
        return undefined;
    }

    let dateArg: string | undefined;

    const { filters } = queryVariables as { filters: Filters };

    if (!filters) {
        return undefined;
    }

    const {
        date,
        moreFilters,
        ...rest
    } = filters;

    const restFilterKeys = Object.keys(rest) as Array<keyof Omit<Filters, 'date' | 'moreFilters'>>;
    const restFilterArgs = restFilterKeys.map(key => (rest[key] || '0'));

    let moreFilterArgs: string[] = [];
    if (moreFilters) {
        const moreFilterKeys = Object.keys(moreFilters) as Array<keyof Filters['moreFilters']>;
        moreFilterArgs = moreFilterKeys.map(key => (moreFilters[key] ? '1' : '0'));
    }

    if (date) {
        dateArg = `${date.from}-${date.to}`;
    }

    return [
        dateArg,
        ...restFilterArgs,
        ...moreFilterArgs,
    ].join();
};

export const buildFromToCacheKeys: KeyArgsFunction = (_args, context) => {
    const queryVariables = context.variables;
    if (!queryVariables) {
        return undefined;
    }

    let dateArg: string | undefined;

    const { dateFromTo } = queryVariables;

    if (dateFromTo) {
        const { from, to } = dateFromTo as DateFromTo;
        dateArg = `${from}-${to}`;
    }

    return dateArg;

};
